class IngredientsCard extends HTMLElement {
    constructor() {
 
      super();
      this.card = this.querySelector('.card__container');
      this.hoverOverlay = this.querySelector('.hover-overlay');
      if (this.card && this.hoverOverlay) {
        this.init();
      }
    }
  
    init() {
 
      if (window.innerWidth <= 768) {
        this.card.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleOverlay();
        });
      }
    }
  
    toggleOverlay() {
      this.hoverOverlay.style.opacity = this.hoverOverlay.style.opacity === '1' ? '0' : '1';
    }
}
  
customElements.define('ingredients-card', IngredientsCard);